import TimeAgoReact from "timeago-react";

interface TimeAgoProps {
	date: string | Date;
	className?: string;
	prefix?: string;
}

export function TimeAgo({ date, className, prefix }: TimeAgoProps) {
	return (
		<span className={className}>
			{prefix && <span>{prefix} </span>}
			<TimeAgoReact datetime={date} />
		</span>
	);
}
